import { Link } from 'react-router-dom';
import { categories, brandInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="font-heading text-xl font-bold text-white">🔥 {brandInfo.name}</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                {brandInfo.slogan}
              </p>
            </div>

            <div>
              <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wide">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wide">快捷链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">关于我们</Link>
                <a href="#subscribe" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">订阅爆料</a>
                <Link to="/category/meiri-dasai" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">每日大赛</Link>
                <Link to="/category/51chigua" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">51吃瓜</Link>
              </div>
            </div>

            <div>
              <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wide">联系我们</h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-foreground-300">
                  <i className="ri-mail-line mr-2"></i>{brandInfo.email}
                </p>
                <p className="text-sm text-foreground-300">
                  <i className="ri-phone-line mr-2"></i>{brandInfo.phone}
                </p>
                <p className="text-sm text-foreground-300">
                  <i className="ri-map-pin-line mr-2"></i>{brandInfo.address}
                </p>
              </div>
              <div className="flex gap-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-500 text-foreground-300 hover:text-white hover:border-white transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-500 text-foreground-300 hover:text-white hover:border-white transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-500 text-foreground-300 hover:text-white hover:border-white transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {brandInfo.name} 版权所有
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}